import service from '@/api/service/service';
import qs from "qs";

// 开班计划管理
export function getClassPlanList(params) {
  return service({
    url: '/api/classPlan/class_plan_list.json',
    method: 'GET',
    params
  })
}

//会员协会提交开班计划
export function classPlanEdit(data = {}) {
  return service({
    url: "/api/classPlan/class_plan_edit.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

//会员协会获取开班计划信息
export function claassPlanOrganInfo(params) {
  return service({
    url: "/api/classPlan/class_plan_info.json",
    method: 'GET',
    params
  });
}

//会员协会获取开班计划信息
export function claassPlanSysInfo(params) {
  return service({
    url: "/api/classPlan/class_plan_info_sys.json",
    method: 'GET',
    params
  });
}

//会员协会获取开班计划信息
export function claassPlanOrganListSys(params) {
  return service({
    url: "/api/classPlan/class_plan_organ_list.json",
    method: 'GET',
    params
  });
}

//会员协会提交开班计划-- 年计划
export function classPlanYearAdd(data = {}) {
  return service({
    url: "/api/classPlan/class_plan_year_add.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

//会员协会提交开班计划-- 年计划
export function classPlanYearEdit(data = {}) {
  return service({
    url: "/api/classPlan/class_plan_year_edit.json",
    method: 'post',
    data: qs.stringify(data),
  });
}
//会员协会获取开班计划信息-- 年计划
export function classPlanOrganInfoYear(params) {
  return service({
    url: "/api/classPlan/class_plan_year_info.json",
    method: 'GET',
    params
  });
}
